module.exports = __webpack_public_path__ + "img/fond-1.8f04242f.png";